var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-container"},[_c('svg',{staticClass:"icon icon-empty",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-kong"}})]),_c('p',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.description || '暂无数据'))])])}
var staticRenderFns = []

export { render, staticRenderFns }